<div class="persistent-bottom-player" cdkDrag>
  <!-- Close Button at the top right -->
  <button class="btn custom-btn close-btn" (click)="closeModal()">
    <i class="fa-solid fa-xmark"></i>
  </button>
  

  <!-- Top Layer (Draggable Handle): Campaign Name and Nazwa kampanii -->
  <div class="top-controls" cdkDragHandle>
    <span class="campaign-name">{{ campaignName }}</span>
    <span class="campaign-kampanii">{{ kampaniaName }}</span>
  </div>

  <!-- Play/Pause, Progress, and Volume Controls -->
  <div class="controls-container">
    <div class="controls">
    <!-- Play/Pause Button -->
    <button class="btn custom-btn play-pause-btn" (click)="togglePlayPause()">
      <i class="fa-solid" [ngClass]="isPaused ? 'fa-play' : 'fa-pause'"></i>
    </button>

      <!-- Progress Bar -->
      <div class="custom-progress" (click)="setAudioProgress($event)">
        <div class="custom-progress-bar" [style.width]="progress + '%'"></div>
      </div>
    </div>

    <!-- Volume Control and Time Display -->
    <div class="volume-time-container">
      <!-- Volume Control -->
      <button class="btn custom-btn volume-btn" (click)="toggleMute()">
        <i class="fas" [ngClass]="audioElementRef?.nativeElement?.volume === 0 ? 'fa-volume-mute' : 'fa-volume-up'"></i>
      </button>
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        [value]="volume"
        (input)="changeVolume($event)"
        class="custom-volume-slider"
      />

      <!-- Time Display -->
      <div class="time-display">
        {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
      </div>
    </div>
  </div>

  <!-- Audio Element (Hidden) -->
  <audio
    #audioElement
    [src]="audioUrl"
    (loadedmetadata)="handleLoadedMetadata()"
    (timeupdate)="handleTimeUpdate()"
    (ended)="handleAudioEnded()"
    [volume]="volume"
    style="display: none"
  ></audio>
</div>
